var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.$style.search },
    [
      _c(
        "Title",
        {
          staticStyle: { padding: "0 0.5em" },
          attrs: { bold: "", strong: "" },
        },
        [_vm._v(" 查詢捐款記錄 ")]
      ),
      _c("RouterView"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }